import React from 'react';
import { ThemeProvider, createTheme } from '@mui/material';
import CssBaseline from '@mui/material/CssBaseline';
import Chatbot from './components/Chatbot';
import { FormProvider } from './context/FormContext';

const theme = createTheme({
  palette: {
    primary: {
      main: '#2196f3',
    },
    secondary: {
      main: '#f50057',
    },
    background: {
      default: '#f5f5f5',
    },
  },
  typography: {
    fontFamily: [
      '-apple-system',
      'BlinkMacSystemFont',
      '"Segoe UI"',
      'Roboto',
      '"Helvetica Neue"',
      'Arial',
      'sans-serif',
    ].join(','),
  },
});

function App () {
  return (
    <FormProvider>
      <ThemeProvider theme={theme}>
        <CssBaseline />
        <Chatbot />
      </ThemeProvider>
    </FormProvider>
  );
}

export default App;
